import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { ETenderAttachmentType, ETenderDTO, ETendersAttachmentDTO, ETenderSupplierDTO, ETenderTypes, ETenderViewAllFieldsDTO, SupplierDTO } from 'src/app/shared/models/e-tender.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Subscription, interval } from 'rxjs';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';

import { SupplierService } from 'src/app/shared/services/supplier.service';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/shared/components/alert/alert.service';

@Component({
  selector: 'app-invite-additional-supplier',
  templateUrl: './invite-additional-supplier.component.html',
  styleUrls: []
})
export class InviteAdditionalSupplierComponent implements OnInit {
  private tenderRequestId = '';
  displayedLang: string;
  responseObj: ResponseObject;
  model: ETenderDTO;
  cats: number[];
  SpecialitiesList: any;
  suppliersDropdownSettings = {};
  suppliersList: any;
  selectedSuppliers: any = [];
  oldSelectedSuppliers:  any;
  showSubmit: boolean = false;
  IsSuccess: boolean = false;
  showRequest: boolean = true;
  addedSuppliers: any;
  message: string;


  constructor( private authSrevice: AuthenticationService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private lookupService: LookupService,
    private supplierService: SupplierService,
    private etenderSrv: EtenderService,
    private translate: TranslateService) {
      this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'Ar' : 'En';
      if (history.state.data && history.state.data.tenderId) {
        this.tenderRequestId = history.state.data.tenderId;
        this.getTenderRequest();
      } else {
        window.history.back();
      }
      this.suppliersDropdownSettings = {
        singleSelection: false,
        idField: 'UserId',
        textField: 'CompanyName',
        selectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
        unSelectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
        allowSearchFilter: true
      };
    }

  ngOnInit() {
  }

  getTenderRequest(): void {
    this.etenderSrv.GetTenderById(this.tenderRequestId).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompleted();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequestCompleted(): void {
    if (this.responseObj.Success) {
      this.model = this.responseObj.Data as ETenderDTO
        this.model.ETendersCategories = this.model.ETendersCategoriesAdmin
          .filter((thing, i, arr) => arr.findIndex(t => t.CategoryId === thing.CategoryId) === i)
          .map(function (e) { return e.Category; });
        this.cats = this.model.ETendersCategories.map(function (e) {
          return e.Id;
        });
        this.getCategoriesDataByIds();
    } else {
      console.log('Something went wrong!!')
    }
  }
  getCategoriesDataByIds() {
    this.etenderSrv.GetCategoriesDataByIds(this.cats).subscribe(c => {
      this.SpecialitiesList = c.Data.Specialities;
      if (this.model != null && this.model.ETenderSuppliers != null && this.model.ETenderSuppliers.length > 0
        && (this.model.TenderTypeId == ETenderTypes.LimitedTender || this.model.TenderTypeId == ETenderTypes.Practice)) {
        const specialityIds: number[] = [];
        for (let i = 0; i < this.model.ETenderSuppliers.length; i++) {
          for (let j = 0; j < this.model.ETenderSuppliers[i].Supplier.SupplierSpecialities.length; j++) {
            specialityIds.push(this.model.ETenderSuppliers[i].Supplier.SupplierSpecialities[j].SpecialityId);
          }
        }
        this.model.Specialities = this.SpecialitiesList.filter(e => specialityIds.includes(e.Id));
        let specsIds: number[];
        if (this.model.Specialities && this.model.Specialities.length > 0) {
          specsIds = this.model.Specialities.map(function (e) {
            return e.Id;
          });
        }
        this.suppliersList = [];
        if (specsIds) {
          this.globalSrv.isLoaderEnabled = true;
          this.supplierService.GetSuppliersBySpecialitiesId(specsIds).subscribe(c => {
            this.suppliersList = c.Data;
            if (this.model != null && this.model.ETenderSuppliers != null && this.model.ETenderSuppliers.length > 0
              && (this.model.TenderTypeId == ETenderTypes.LimitedTender || this.model.TenderTypeId == ETenderTypes.Practice)) {
                let supplierIds: string[] = [];
              supplierIds = this.model.ETenderSuppliers.map(function (e) { return e.Supplier.UserId; });
              this.oldSelectedSuppliers = this.suppliersList.filter(e => supplierIds.includes(e.UserId));
              this.model.Suppliers = this.suppliersList.filter(ss => this.oldSelectedSuppliers.every(oss => oss.UserId !== ss.UserId));
            }
            this.globalSrv.isLoaderEnabled = false;
          });
        }
      }

    });
  }
  SuppliersChanged(){
      if (this.selectedSuppliers.length > 0) {
        this.showSubmit = true;
      } else {
        this.showSubmit = false;
      }
    }

  onSubmit() {
    if (this.selectedSuppliers.length > 0){
      this.globalSrv.isLoaderEnabled = true;
      this.model.ETenderSuppliers = this.selectedSuppliers.map(function (currItem) {
        const supplier = {} as ETenderSupplierDTO;
        supplier.SupplierId = currItem.UserId;
        return supplier;
      });
      this.etenderSrv.AddAdditionalSupplier(this.model).subscribe(
        (data: ResponseObject) => {
          this.responseObj = data;
          if (this.responseObj.Success) {
            this.IsSuccess = true;
            this.showRequest = false;
            this.globalSrv.isLoaderEnabled = false;
            this.translate.get('ADMIN_USER.E_TENDER_FORM.ADD_SUPPLIER_MSG').subscribe((response: string) => {
              this.message = response;
            });
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.IsSuccess = true;
            this.showRequest = false;
            this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }
        });
    }
  }
}

